import { apiService } from './api';

export interface OrderRequestNotification {
  id: string;
  restaurantId: string;
  tableId: string;
  tableName?: string;
  organizationCode: string;
  customerName: string;
  customerMobile: string;
  items: {
    itemId: string;
    itemName: string;
    quantity: number;
    unitPrice: number;
    specialNotes?: string;
  }[];
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface WaiterCallNotification {
  id: string;
  restaurantId: string;
  tableId: string;
  tableName: string;
  organizationCode: string;
  status: string;
  createdAt: string;
}

export const orderRequestService = {
  getPendingRequests: async (restaurantId: string): Promise<OrderRequestNotification[]> => {
    const res = await apiService.get<OrderRequestNotification[]>(
      `/public/order-requests/${restaurantId}`,
      { status: 'PENDING' }
    );
    return res.data;
  },

  getAllRequests: async (restaurantId: string): Promise<OrderRequestNotification[]> => {
    const res = await apiService.get<OrderRequestNotification[]>(
      `/public/order-requests/${restaurantId}`
    );
    return res.data;
  },

  acceptRequest: async (id: string): Promise<OrderRequestNotification> => {
    const res = await apiService.patch<OrderRequestNotification>(
      `/public/order-requests/${id}/accept`
    );
    return res.data;
  },

  rejectRequest: async (id: string): Promise<OrderRequestNotification> => {
    const res = await apiService.patch<OrderRequestNotification>(
      `/public/order-requests/${id}/reject`
    );
    return res.data;
  },

  getPendingWaiterCalls: async (restaurantId: string): Promise<WaiterCallNotification[]> => {
    const res = await apiService.get<WaiterCallNotification[]>(
      `/public/waiter-calls/${restaurantId}`,
      { status: 'PENDING' }
    );
    return res.data;
  },

  getAllWaiterCalls: async (restaurantId: string): Promise<WaiterCallNotification[]> => {
    const res = await apiService.get<WaiterCallNotification[]>(
      `/public/waiter-calls/${restaurantId}`
    );
    return res.data;
  },

  acknowledgeWaiterCall: async (id: string): Promise<WaiterCallNotification> => {
    const res = await apiService.patch<WaiterCallNotification>(
      `/public/waiter-calls/${id}/acknowledge`
    );
    return res.data;
  },
};
